var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_outward_FILL0_wght400_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.09996 4.13359L4.79996 3.43359L11.6666 10.3003L11.6666 4.00026L12.6666 4.00026L12.6666 12.0003L4.66663 12.0003L4.66663 11.0003L10.9666 11.0003L4.09996 4.13359Z",
    fill: "#008A35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPositive);
export default __webpack_public_path__ + "static/media/arrow-positive.b4f10e42381fed745e76f82d63d46ed9.svg";
export { ForwardRef as ReactComponent };